require("../articles-content/articles-content");
require("../categories-content/categories-content");
require("../about-content/about-content");

const adminRoot = document.querySelector("[data-admin-root]");

const BLOCK_LABELS = {
  heading: "Заголовок",
  section: "Раздел",
  text: "Текст",
  image: "Фото",
  list: "Список",
  cta: "Кнопка действия",
  slider: "Слайдер",
};

const CTA_ACTION_LABELS = {
  popup: "Заявка",
  service: "Услуга",
  link: "Ссылка",
};

function initAdminArticlesContent() {
  const store = window.NMArticlesContent;
  const aboutStore = window.NMAboutContent;
  const categoriesStore = window.NMCategoriesContent;
  if (!store || !adminRoot || window.NMAdminArticlesContent) return;

  async function uploadImageFile(file) {
    if (!file) return "";
    if (!window.NMApi?.uploadFile) {
      window.alert("Загрузка файлов недоступна. Обновите страницу и попробуйте снова."); // eslint-disable-line no-alert
      return "";
    }
    try {
      const payload = await window.NMApi.uploadFile(file);
      return String(payload?.url || "");
    } catch (error) {
      window.alert(error?.message || "Не удалось загрузить изображение"); // eslint-disable-line no-alert
      return "";
    }
  }

  const contentHome = document.querySelector("[data-content-home]");
  const articlesEditor = document.querySelector('[data-content-editor="articles"]');
  const articlesItemEditor = document.querySelector('[data-content-editor="articles-item"]');
  const aboutEditor = document.querySelector('[data-content-editor="about"]');
  const homeEditor = document.querySelector('[data-content-editor="home"]');
  const portfolioEditor = document.querySelector('[data-content-editor="portfolio"]');
  const contactsEditor = document.querySelector('[data-content-editor="contacts"]');
  const servicesEditor = document.querySelector('[data-content-editor="services"]');
  const categoriesEditor = document.querySelector('[data-content-editor="categories"]');
  const categoriesItemEditor = document.querySelector('[data-content-editor="categories-item"]');

  const articlesList = document.querySelector("[data-articles-admin-list]");
  const articlesCount = document.querySelector("[data-articles-count]");
  const articleCreateBtn = document.querySelector("[data-articles-create]");
  const itemBackBtn = document.querySelector("[data-articles-item-back]");
  const itemPageTitle = document.querySelector("[data-articles-item-page-title]");
  const itemPreviewLink = document.querySelector("[data-articles-item-preview]");
  const itemNote = document.querySelector("[data-articles-item-note]");
  const itemError = document.querySelector("[data-articles-item-error]");

  const articleForm = document.querySelector("[data-articles-form]");
  const articleDeleteBtn = document.querySelector("[data-articles-delete]");
  const categoriesBox = document.querySelector("[data-articles-categories]");
  const coverImageInput = document.querySelector("#articles-cover-image");
  const coverImageData = document.querySelector("[data-articles-cover-image-data]");
  const coverImagePreview = document.querySelector("[data-articles-cover-image-preview]");
  const coverImageReset = document.querySelector("[data-articles-cover-image-reset]");
  const authorSelect = articleForm?.elements.authorId;
  const blocksList = document.querySelector("[data-articles-blocks-list]");
  const blockTypeSelect = document.querySelector("[data-articles-block-type]");
  const blockCreateBtn = document.querySelector("[data-articles-block-create]");

  const blockModal = document.querySelector("[data-articles-block-modal]");
  const blockForm = document.querySelector("[data-articles-block-form]");
  const blockFormTitle = document.querySelector("[data-articles-block-form-title]");
  const blockFormDesc = document.querySelector("[data-articles-block-form-desc]");
  const blockFields = document.querySelector("[data-articles-block-fields]");
  const blockIdInput = document.querySelector("[data-articles-block-id]");
  const blockTypeValue = document.querySelector("[data-articles-block-type-value]");

  let draftArticle = null;
  let editingBlockId = null;
  let noteTimer = null;

  function hideOtherEditors() {
    if (contentHome) contentHome.hidden = true;
    if (aboutEditor) aboutEditor.hidden = true;
    if (homeEditor) homeEditor.hidden = true;
    if (portfolioEditor) portfolioEditor.hidden = true;
    if (contactsEditor) contactsEditor.hidden = true;
    if (servicesEditor) servicesEditor.hidden = true;
    if (categoriesEditor) categoriesEditor.hidden = true;
    if (categoriesItemEditor) categoriesItemEditor.hidden = true;
    const faqEditor = document.querySelector('[data-content-editor="faq"]');
    if (faqEditor) faqEditor.hidden = true;
  }

  function hideSaveError() {
    if (!itemError) return;
    itemError.hidden = true;
    itemError.textContent = "";
  }

  function showSaveError(message) {
    if (itemNote) itemNote.hidden = true;
    if (!itemError) {
      window.alert(message); // eslint-disable-line no-alert
      return;
    }
    itemError.textContent = message;
    itemError.hidden = false;
    itemError.scrollIntoView({ block: "nearest", behavior: "smooth" });
  }

  function showNote() {
    hideSaveError();
    if (!itemNote) return;
    itemNote.hidden = false;
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(() => {
      itemNote.hidden = true;
    }, 2200);
  }

  function readFieldValue(name) {
    const control = articleForm?.querySelector(`[name="${name}"]`);
    return String(control?.value || "").trim();
  }

  function getTeamPeople() {
    if (!aboutStore) return [];
    const data = aboutStore.getAboutData();
    const keys = aboutStore.TEAM_KEYS || ["leaders", "marketing", "designers", "production"];
    return keys.flatMap((key) => (data.teams?.[key] || []).map((person) => ({
      ...person,
      teamKey: key,
    })));
  }

  function resolveAuthorSnapshot(authorId, fallback = {}) {
    const person = getTeamPeople().find((item) => String(item.id) === String(authorId));
    if (!person) {
      return {
        authorId: String(authorId || "").trim(),
        authorName: String(fallback.authorName || "").trim(),
        authorPost: String(fallback.authorPost || "").trim(),
        authorImage: String(fallback.authorImage || "").trim() || store.DEFAULT_AUTHOR_IMAGE,
      };
    }
    return {
      authorId: String(person.id),
      authorName: person.name || "",
      authorPost: person.post || "",
      authorImage: person.image || store.DEFAULT_AUTHOR_IMAGE,
    };
  }

  function updateCoverPreview(src) {
    if (!coverImagePreview) return;
    const img = coverImagePreview.querySelector("img");
    if (!src) {
      coverImagePreview.hidden = true;
      if (img) img.src = "";
      return;
    }
    if (img) img.src = src;
    coverImagePreview.hidden = false;
  }

  function clearArticleErrors() {
    articleForm?.querySelectorAll("[data-articles-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-articles-error]");
      if (error) error.hidden = true;
    });
  }

  function showArticleError(name) {
    const field = articleForm?.querySelector(`[data-articles-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-articles-error]");
    if (error) error.hidden = false;
  }

  function closeBlockModal() {
    if (!blockModal) return;
    blockModal.hidden = true;
    editingBlockId = null;
    document.body.classList.remove("is-admin-modal-open");
    if (blockForm) blockForm.reset();
    if (blockFields) blockFields.innerHTML = "";
  }

  function emptyDraft() {
    return {
      id: store.createId(),
      slug: "",
      title: "",
      excerpt: "",
      coverImage: "",
      publishedAt: store.todayIso(),
      categoryKeys: [],
      authorId: "",
      authorName: "",
      authorPost: "",
      authorImage: "",
      blocks: [],
    };
  }

  function cloneArticle(article) {
    return {
      ...article,
      categoryKeys: [...(article.categoryKeys || [])],
      blocks: (article.blocks || []).map((block) => ({
        ...block,
        items: Array.isArray(block.items) ? [...block.items] : undefined,
        slides: Array.isArray(block.slides)
          ? block.slides.map((slide) => ({ ...slide }))
          : undefined,
      })),
    };
  }

  function fillAuthorSelect(selectedId) {
    if (!authorSelect) return;
    const people = getTeamPeople();
    const selected = String(selectedId || "");
    authorSelect.innerHTML = `
      <option value="">Выберите автора</option>
      ${people.map((person) => `
        <option value="${store.escapeHtml(person.id)}" ${String(person.id) === selected ? "selected" : ""}>
          ${store.escapeHtml(person.name)}${person.post ? ` — ${store.escapeHtml(person.post)}` : ""}
        </option>
      `).join("")}
    `;
    if (selected && !people.some((person) => String(person.id) === selected)) {
      authorSelect.value = "";
    }
  }

  function fillCategories(selectedKeys = []) {
    if (!categoriesBox) return;
    const categories = categoriesStore?.getCategories?.() || [];
    if (!categories.length) {
      categoriesBox.innerHTML = `<p class="admin-panel__hint p3">Сначала добавьте категории в разделе «Категории»</p>`;
      return;
    }
    categoriesBox.innerHTML = categories.map((category) => `
      <label class="admin-panel__article-category">
        <input type="checkbox" name="categoryKeys" value="${store.escapeHtml(category.key)}" ${selectedKeys.includes(category.key) ? "checked" : ""} />
        <span>${store.escapeHtml(category.title)}</span>
      </label>
    `).join("");
  }

  function getServiceOptionsHtml(selectedKey = "") {
    const categories = categoriesStore?.getCategories?.() || [];
    return `
      <option value="">Выберите услугу</option>
      ${categories.map((category) => `
        <option value="${store.escapeHtml(category.key)}" ${category.key === selectedKey ? "selected" : ""}>
          ${store.escapeHtml(category.title)}
        </option>
      `).join("")}
    `;
  }

  function syncBlockCtaFields() {
    const actionSelect = blockFields?.querySelector("[name=\"action\"]");
    const serviceField = blockFields?.querySelector("[data-block-cta-service]");
    const linkField = blockFields?.querySelector("[data-block-cta-link]");
    const action = String(actionSelect?.value || "popup");
    if (serviceField) serviceField.hidden = action !== "service";
    if (linkField) linkField.hidden = action !== "link";
  }

  function blockPreview(block) {
    switch (block.type) {
      case "heading":
        return `H${block.level}: ${block.text}${block.accent ? ` ${block.accent}` : ""}`;
      case "section":
        return `${block.text}${block.accent ? ` ${block.accent}` : ""}`;
      case "text":
        return block.text.slice(0, 120);
      case "image":
        return block.alt || "Изображение";
      case "list":
        return `${block.ordered ? "Нумерованный" : "Маркированный"} · ${block.items.length} пункт(ов)`;
      case "cta":
        return `${block.label} · ${CTA_ACTION_LABELS[block.action] || block.action}`;
      case "slider":
        return `${block.slides.length} слайд(ов)`;
      default:
        return "";
    }
  }

  function renderBlocksAdmin() {
    if (!blocksList || !draftArticle) return;
    const items = draftArticle.blocks || [];
    if (!items.length) {
      blocksList.innerHTML = `
        <div class="admin-panel__article-empty">
          <p class="admin-panel__article-empty-title">Блоков пока нет</p>
          <p class="admin-panel__hint p3">Добавьте заголовок, раздел, текст, фото, список или слайдер</p>
        </div>
      `;
      return;
    }

    blocksList.innerHTML = items.map((block, index) => `
      <article class="admin-panel__article-block-card">
        <div class="admin-panel__article-block-card-body">
          <span class="admin-panel__article-block-type">${BLOCK_LABELS[block.type] || block.type}</span>
          <p class="admin-panel__article-block-preview">${store.escapeHtml(blockPreview(block))}</p>
        </div>
        <div class="admin-panel__article-block-card-actions">
          <button class="admin-panel__action-btn" type="button" data-articles-block-up="${store.escapeHtml(block.id)}" ${index === 0 ? "disabled" : ""}>↑</button>
          <button class="admin-panel__action-btn" type="button" data-articles-block-down="${store.escapeHtml(block.id)}" ${index === items.length - 1 ? "disabled" : ""}>↓</button>
          <button class="admin-panel__action-btn" type="button" data-articles-block-edit="${store.escapeHtml(block.id)}">Изменить</button>
          <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-articles-block-delete="${store.escapeHtml(block.id)}">Удалить</button>
        </div>
      </article>
    `).join("");
  }

  function renderArticlesAdmin() {
    const articles = store.getArticles();
    if (articlesCount) articlesCount.textContent = `Статей: ${articles.length}`;
    if (!articlesList) return;

    if (!articles.length) {
      articlesList.innerHTML = `
        <div class="admin-panel__article-empty">
          <p class="admin-panel__article-empty-title">Пока нет статей</p>
          <p class="admin-panel__hint p3">Создайте первую статью для раздела /articles</p>
        </div>
      `;
      return;
    }

    articlesList.innerHTML = articles.map((article) => {
      const cats = store.getCategoryTitles(article.categoryKeys).slice(0, 3);
      return `
        <article class="admin-panel__article-card">
          <div class="admin-panel__article-card-media">
            <img src="${store.escapeHtml(article.coverImage || store.DEFAULT_COVER)}" alt="" width="96" height="96" />
          </div>
          <div class="admin-panel__article-card-body">
            <h4 class="admin-panel__article-card-title">${store.escapeHtml(article.title)}</h4>
            ${article.excerpt ? `<p class="admin-panel__article-card-desc">${store.escapeHtml(article.excerpt)}</p>` : ""}
            <div class="admin-panel__article-card-tags">
              <span class="admin-panel__article-stat">${store.escapeHtml(store.formatDate(article.publishedAt) || "—")}</span>
              ${article.authorName ? `<span class="admin-panel__article-stat">${store.escapeHtml(article.authorName)}</span>` : ""}
              ${cats.map((cat) => `<span class="admin-panel__article-stat">${store.escapeHtml(cat.title)}</span>`).join("")}
            </div>
          </div>
          <div class="admin-panel__article-card-actions">
            <button class="admin-panel__action-btn" type="button" data-articles-open="${store.escapeHtml(article.id)}">Настроить</button>
            <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-articles-remove="${store.escapeHtml(article.id)}">Удалить</button>
          </div>
        </article>
      `;
    }).join("");
  }

  function setFieldValue(name, value) {
    const control = articleForm?.querySelector(`[name="${name}"]`);
    if (!control || control.type === "file") return;
    control.value = value;
  }

  function fillItemForm() {
    if (!articleForm || !draftArticle) return;
    hideSaveError();
    setFieldValue("title", draftArticle.title || "");
    setFieldValue("excerpt", draftArticle.excerpt || "");
    setFieldValue("publishedAt", draftArticle.publishedAt || store.todayIso());
    fillAuthorSelect(draftArticle.authorId);
    fillCategories(draftArticle.categoryKeys);

    const coverSrc = draftArticle.coverImage && draftArticle.coverImage !== store.DEFAULT_COVER
      ? draftArticle.coverImage
      : (draftArticle.coverImage || "");
    if (coverImageData) coverImageData.value = coverSrc || draftArticle.coverImage || "";
    if (coverImageInput) coverImageInput.value = "";
    updateCoverPreview(coverImageData?.value || draftArticle.coverImage || "");

    if (itemPageTitle) {
      itemPageTitle.innerHTML = draftArticle.title
        ? `<span>${store.escapeHtml(draftArticle.title)}</span>`
        : "<span>Новая статья</span>";
    }
    if (itemPreviewLink) {
      itemPreviewLink.href = draftArticle.slug
        ? store.getArticlePath(draftArticle)
        : "/articles";
    }
    if (articleDeleteBtn) {
      const exists = Boolean(store.getArticleById(draftArticle.id));
      articleDeleteBtn.hidden = !exists;
    }

    renderBlocksAdmin();
  }

  async function showArticlesEditor() {
    hideOtherEditors();
    if (articlesItemEditor) articlesItemEditor.hidden = true;
    if (articlesEditor) articlesEditor.hidden = false;
    draftArticle = null;
    closeBlockModal();
    try {
      await store.refreshArticlesFromServer?.();
    } catch (error) {
      // keep current cache if offline
    }
    renderArticlesAdmin();
  }

  function showItemEditor(articleId) {
    hideOtherEditors();
    if (articlesEditor) articlesEditor.hidden = true;
    if (articlesItemEditor) articlesItemEditor.hidden = false;
    const existing = articleId ? store.getArticleById(articleId) : null;
    draftArticle = existing ? cloneArticle(existing) : emptyDraft();
    clearArticleErrors();
    fillItemForm();
  }

  function getSelectedCategoryKeys() {
    if (!categoriesBox) return [];
    return Array.from(categoriesBox.querySelectorAll('input[name="categoryKeys"]:checked'))
      .map((input) => input.value);
  }

  async function persistDraft({ silent = false } = {}) {
    if (!draftArticle || !articleForm) return null;
    clearArticleErrors();
    hideSaveError();

    const title = readFieldValue("title");
    const excerpt = readFieldValue("excerpt");
    const publishedAt = readFieldValue("publishedAt");
    const authorId = readFieldValue("authorId");
    const categoryKeys = getSelectedCategoryKeys();
    const coverImage = String(coverImageData?.value || "").trim();

    let hasError = false;
    if (!title) {
      showArticleError("title");
      hasError = true;
    }
    if (!publishedAt) {
      showArticleError("publishedAt");
      hasError = true;
    }
    if (!authorId) {
      showArticleError("authorId");
      hasError = true;
    }
    if (!categoryKeys.length) {
      showArticleError("categoryKeys");
      hasError = true;
    }
    if (hasError) {
      if (!silent) {
        showSaveError("Заполните обязательные поля выше, затем сохраните статью ещё раз");
        articleForm.querySelector("[data-articles-field].has-error")?.scrollIntoView({
          block: "center",
          behavior: "smooth",
        });
      }
      return null;
    }

    const authorSnapshot = resolveAuthorSnapshot(authorId, draftArticle);
    if (!authorSnapshot.authorName) {
      showArticleError("authorId");
      if (!silent) showSaveError("Выберите автора из команды «О компании»");
      return null;
    }

    draftArticle.title = title;
    draftArticle.titleHtml = store.buildTitleHtml(title);
    draftArticle.excerpt = excerpt;
    draftArticle.publishedAt = publishedAt;
    draftArticle.categoryKeys = categoryKeys;
    draftArticle.coverImage = coverImage || store.DEFAULT_COVER;
    draftArticle.authorId = authorSnapshot.authorId;
    draftArticle.authorName = authorSnapshot.authorName;
    draftArticle.authorPost = authorSnapshot.authorPost;
    draftArticle.authorImage = authorSnapshot.authorImage;
    if (!draftArticle.slug) {
      draftArticle.slug = store.uniqueSlug(
        store.slugify(title),
        draftArticle.id,
        store.getArticles(),
      );
    }

    try {
      return await store.upsertArticle(draftArticle);
    } catch (error) {
      const message = error?.message || "Не удалось сохранить статью";
      if (!silent) showSaveError(message);
      else window.alert(message); // eslint-disable-line no-alert
      renderArticlesAdmin();
      return null;
    }
  }

  async function moveBlock(id, direction) {
    if (!draftArticle) return;
    const index = draftArticle.blocks.findIndex((item) => item.id === id);
    if (index < 0) return;
    const next = index + direction;
    if (next < 0 || next >= draftArticle.blocks.length) return;
    const copy = [...draftArticle.blocks];
    const [item] = copy.splice(index, 1);
    copy.splice(next, 0, item);
    draftArticle.blocks = copy;
    renderBlocksAdmin();
    const saved = await persistDraft({ silent: true });
    if (saved) {
      draftArticle = cloneArticle(saved);
      fillItemForm();
    }
  }

  function bindSliderFields() {
    const root = blockFields?.querySelector("[data-articles-block-slides]");
    if (!root) return;

    root.querySelectorAll("[data-slide-file]").forEach((input) => {
      input.addEventListener("change", async () => {
        const file = input.files?.[0];
        if (!file) return;
        const slide = input.closest("[data-slide-index]");
        input.disabled = true;
        const url = await uploadImageFile(file);
        input.disabled = false;
        input.value = "";
        if (!url) return;
        const hidden = slide?.querySelector("[data-slide-image]");
        const preview = slide?.querySelector(".admin-modal__upload-preview");
        if (hidden) hidden.value = url;
        if (preview) {
          const img = preview.querySelector("img");
          if (img) img.src = url;
          preview.hidden = false;
        }
      });
    });

    root.querySelectorAll("[data-slide-remove]").forEach((button) => {
      button.addEventListener("click", () => {
        button.closest("[data-slide-index]")?.remove();
      });
    });

    blockFields.querySelector("[data-articles-slide-add]")?.addEventListener("click", () => {
      const index = root.querySelectorAll("[data-slide-index]").length;
      if (index >= 8) return;
      const node = document.createElement("div");
      node.className = "admin-panel__article-slide";
      node.setAttribute("data-slide-index", String(index));
      node.innerHTML = `
        <input type="hidden" data-slide-image value="" />
        <div class="admin-modal__upload-preview" hidden>
          <img src="" alt="" width="120" height="80" />
        </div>
        <input class="admin-modal__field-control" type="text" data-slide-caption maxlength="120" value="" placeholder="Подпись" />
        <label class="admin-modal__upload" for="articles-slide-file-${index}">
          <span class="admin-modal__upload-title">Фото</span>
        </label>
        <input id="articles-slide-file-${index}" class="visually-hidden" type="file" accept="image/*" data-slide-file />
        <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-slide-remove>Удалить</button>
      `;
      root.appendChild(node);
      bindSliderFields();
    }, { once: true });
  }

  function renderBlockFields(type, block = {}) {
    if (!blockFields) return;
    if (type === "heading") {
      blockFields.innerHTML = `
        <div class="admin-modal__field-row">
          <div class="admin-modal__field">
            <label class="admin-modal__field-label" for="articles-block-level">Уровень</label>
            <select id="articles-block-level" class="admin-modal__field-control admin-modal__field-control_select" name="level">
              ${[1, 2, 3, 4, 5].map((level) => `
                <option value="${level}" ${Number(block.level || 2) === level ? "selected" : ""}>H${level}</option>
              `).join("")}
            </select>
          </div>
          <div class="admin-modal__field">
            <label class="admin-modal__field-label" for="articles-block-accent">Акцент в span</label>
            <input id="articles-block-accent" class="admin-modal__field-control" type="text" name="accent" maxlength="80" value="${store.escapeHtml(block.accent || "")}" placeholder="H1" />
          </div>
        </div>
        <div class="admin-modal__field">
          <label class="admin-modal__field-label" for="articles-block-text">Текст заголовка</label>
          <input id="articles-block-text" class="admin-modal__field-control" type="text" name="text" maxlength="200" required value="${store.escapeHtml(block.text || "")}" />
        </div>
      `;
      return;
    }

    if (type === "section") {
      blockFields.innerHTML = `
        <div class="admin-modal__field">
          <label class="admin-modal__field-label" for="articles-block-text">Название раздела</label>
          <input id="articles-block-text" class="admin-modal__field-control" type="text" name="text" maxlength="200" required value="${store.escapeHtml(block.text || "")}" />
        </div>
        <div class="admin-modal__field">
          <label class="admin-modal__field-label" for="articles-block-accent">Акцент</label>
          <input id="articles-block-accent" class="admin-modal__field-control" type="text" name="accent" maxlength="40" value="${store.escapeHtml(block.accent || "")}" placeholder="1" />
        </div>
      `;
      return;
    }

    if (type === "text") {
      blockFields.innerHTML = `
        <div class="admin-modal__field">
          <label class="admin-modal__field-label" for="articles-block-variant">Размер текста</label>
          <select id="articles-block-variant" class="admin-modal__field-control admin-modal__field-control_select" name="variant">
            <option value="normal" ${block.variant === "normal" || !block.variant ? "selected" : ""}>Обычный</option>
            <option value="large" ${block.variant === "large" ? "selected" : ""}>Крупный (strong)</option>
            <option value="bold" ${block.variant === "bold" ? "selected" : ""}>Жирный (b)</option>
          </select>
        </div>
        <div class="admin-modal__field">
          <label class="admin-modal__field-label" for="articles-block-text">Текст</label>
          <p class="admin-modal__field-hint p3">Ссылка: [текст ссылки](https://example.com)</p>
          <textarea id="articles-block-text" class="admin-modal__field-control admin-modal__field-control_area" name="text" rows="6" required>${store.escapeHtml(block.text || "")}</textarea>
        </div>
      `;
      return;
    }

    if (type === "image") {
      blockFields.innerHTML = `
        <div class="admin-modal__field">
          <label class="admin-modal__field-label" for="articles-block-alt">Подпись / alt</label>
          <input id="articles-block-alt" class="admin-modal__field-control" type="text" name="alt" maxlength="160" value="${store.escapeHtml(block.alt || "")}" />
        </div>
        <div class="admin-modal__field">
          <span class="admin-modal__field-label">Фото</span>
          <label class="admin-modal__upload" for="articles-block-image">
            <span class="admin-modal__upload-title">Выбрать фото</span>
            <span class="admin-modal__upload-hint">JPG, PNG или WebP</span>
          </label>
          <input id="articles-block-image" class="visually-hidden" type="file" accept="image/*" />
          <input type="hidden" name="src" value="${store.escapeHtml(block.src || "")}" data-articles-block-image-data />
          <div class="admin-modal__upload-preview" data-articles-block-image-preview ${block.src ? "" : "hidden"}>
            <img src="${store.escapeHtml(block.src || "")}" alt="Превью" width="160" height="100" />
          </div>
        </div>
      `;
      const fileInput = blockFields.querySelector("#articles-block-image");
      const hidden = blockFields.querySelector("[data-articles-block-image-data]");
      const preview = blockFields.querySelector("[data-articles-block-image-preview]");
      fileInput?.addEventListener("change", async () => {
        const file = fileInput.files?.[0];
        if (!file) return;
        fileInput.disabled = true;
        const url = await uploadImageFile(file);
        fileInput.disabled = false;
        fileInput.value = "";
        if (!url) return;
        if (hidden) hidden.value = url;
        if (preview) {
          const img = preview.querySelector("img");
          if (img) img.src = url;
          preview.hidden = false;
        }
      });
      return;
    }

    if (type === "list") {
      blockFields.innerHTML = `
        <div class="admin-modal__field">
          <label class="admin-modal__field-label" for="articles-block-ordered">Тип списка</label>
          <select id="articles-block-ordered" class="admin-modal__field-control admin-modal__field-control_select" name="ordered">
            <option value="0" ${!block.ordered ? "selected" : ""}>Маркированный</option>
            <option value="1" ${block.ordered ? "selected" : ""}>Нумерованный</option>
          </select>
        </div>
        <div class="admin-modal__field">
          <label class="admin-modal__field-label" for="articles-block-items">Пункты</label>
          <p class="admin-modal__field-hint p3">Каждый пункт с новой строки. Ссылки: [текст](url)</p>
          <textarea id="articles-block-items" class="admin-modal__field-control admin-modal__field-control_area" name="items" rows="7" required>${store.escapeHtml((block.items || []).join("\n"))}</textarea>
        </div>
      `;
      return;
    }

    if (type === "cta") {
      const action = block.action || "popup";
      blockFields.innerHTML = `
        <div class="admin-modal__field">
          <label class="admin-modal__field-label" for="articles-block-cta-label">Текст кнопки</label>
          <input id="articles-block-cta-label" class="admin-modal__field-control" type="text" name="label" maxlength="80" required value="${store.escapeHtml(block.label || "")}" placeholder="Например: Оставить заявку" />
        </div>
        <div class="admin-modal__field">
          <label class="admin-modal__field-label" for="articles-block-cta-action">Куда ведёт кнопка</label>
          <select id="articles-block-cta-action" class="admin-modal__field-control admin-modal__field-control_select" name="action">
            <option value="popup" ${action === "popup" ? "selected" : ""}>Открыть заявку</option>
            <option value="service" ${action === "service" ? "selected" : ""}>Перейти на услугу</option>
            <option value="link" ${action === "link" ? "selected" : ""}>Своя ссылка</option>
          </select>
        </div>
        <div class="admin-modal__field" data-block-cta-service ${action === "service" ? "" : "hidden"}>
          <label class="admin-modal__field-label" for="articles-block-cta-service">Услуга</label>
          <select id="articles-block-cta-service" class="admin-modal__field-control admin-modal__field-control_select" name="serviceKey">
            ${getServiceOptionsHtml(block.serviceKey || "")}
          </select>
        </div>
        <div class="admin-modal__field" data-block-cta-link ${action === "link" ? "" : "hidden"}>
          <label class="admin-modal__field-label" for="articles-block-cta-href">Ссылка</label>
          <input id="articles-block-cta-href" class="admin-modal__field-control" type="text" name="href" maxlength="400" value="${store.escapeHtml(block.href || "")}" placeholder="https://… или /contacts" />
        </div>
      `;
      blockFields.querySelector("[name=\"action\"]")?.addEventListener("change", syncBlockCtaFields);
      syncBlockCtaFields();
      return;
    }

    if (type === "slider") {
      const slides = block.slides || [];
      blockFields.innerHTML = `
        <div class="admin-modal__field">
          <span class="admin-modal__field-label">Слайды</span>
          <p class="admin-modal__field-hint p3">Добавьте 1–8 фото. Подпись необязательна</p>
          <div class="admin-panel__article-slides" data-articles-block-slides>
            ${slides.map((slide, index) => `
              <div class="admin-panel__article-slide" data-slide-index="${index}">
                <input type="hidden" data-slide-image value="${store.escapeHtml(slide.image || "")}" />
                <div class="admin-modal__upload-preview" ${slide.image ? "" : "hidden"}>
                  <img src="${store.escapeHtml(slide.image || "")}" alt="" width="120" height="80" />
                </div>
                <input class="admin-modal__field-control" type="text" data-slide-caption maxlength="120" value="${store.escapeHtml(slide.caption || "")}" placeholder="Подпись" />
                <label class="admin-modal__upload" for="articles-slide-file-${index}">
                  <span class="admin-modal__upload-title">Фото</span>
                </label>
                <input id="articles-slide-file-${index}" class="visually-hidden" type="file" accept="image/*" data-slide-file />
                <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-slide-remove>Удалить</button>
              </div>
            `).join("")}
          </div>
          <button class="admin-panel__users-add btn btn_m" type="button" data-articles-slide-add>
            <span>Добавить слайд</span>
          </button>
        </div>
      `;
      bindSliderFields();
    }
  }

  function openBlockModal(type, blockId) {
    if (!draftArticle || !blockModal || !blockForm) return;
    const existing = blockId
      ? draftArticle.blocks.find((item) => item.id === blockId)
      : null;
    editingBlockId = existing?.id || null;
    const blockType = existing?.type || type || "text";

    if (blockIdInput) blockIdInput.value = existing?.id || "";
    if (blockTypeValue) blockTypeValue.value = blockType;
    if (blockFormTitle) {
      blockFormTitle.textContent = existing
        ? `Изменить: ${BLOCK_LABELS[blockType] || blockType}`
        : `Новый блок: ${BLOCK_LABELS[blockType] || blockType}`;
    }
    if (blockFormDesc) {
      blockFormDesc.textContent = "Содержимое появится на странице статьи в том же порядке";
    }

    renderBlockFields(blockType, existing || {});
    blockModal.hidden = false;
    document.body.classList.add("is-admin-modal-open");
  }

  function readBlockFromForm() {
    if (!blockForm) return null;
    const type = String(blockTypeValue?.value || "").trim();
    const id = editingBlockId || store.createId();

    if (type === "heading") {
      return store.normalizeBlock({
        id,
        type,
        level: Number(blockForm.elements.level?.value || 2),
        text: blockForm.elements.text?.value,
        accent: blockForm.elements.accent?.value,
      });
    }
    if (type === "section") {
      return store.normalizeBlock({
        id,
        type,
        text: blockForm.elements.text?.value,
        accent: blockForm.elements.accent?.value,
      });
    }
    if (type === "text") {
      return store.normalizeBlock({
        id,
        type,
        text: blockForm.elements.text?.value,
        variant: blockForm.elements.variant?.value,
      });
    }
    if (type === "image") {
      const src = blockFields?.querySelector("[data-articles-block-image-data]")?.value
        || blockForm.elements.src?.value;
      return store.normalizeBlock({
        id,
        type,
        src,
        alt: blockForm.elements.alt?.value,
      });
    }
    if (type === "list") {
      const items = String(blockForm.elements.items?.value || "")
        .split("\n")
        .map((item) => item.trim())
        .filter(Boolean);
      return store.normalizeBlock({
        id,
        type,
        ordered: String(blockForm.elements.ordered?.value || "") === "1",
        items,
      });
    }
    if (type === "cta") {
      return store.normalizeBlock({
        id,
        type,
        label: blockForm.elements.label?.value,
        action: blockForm.elements.action?.value,
        serviceKey: blockForm.elements.serviceKey?.value,
        href: blockForm.elements.href?.value,
      });
    }
    if (type === "slider") {
      const slides = Array.from(blockFields?.querySelectorAll("[data-slide-index]") || [])
        .map((node) => ({
          image: node.querySelector("[data-slide-image]")?.value || "",
          caption: node.querySelector("[data-slide-caption]")?.value || "",
        }))
        .filter((slide) => slide.image);
      return store.normalizeBlock({
        id,
        type,
        slides,
      });
    }
    return null;
  }

  document.querySelectorAll("[data-content-open=\"articles\"]").forEach((button) => {
    button.addEventListener("click", showArticlesEditor);
  });

  articleCreateBtn?.addEventListener("click", () => showItemEditor(null));
  itemBackBtn?.addEventListener("click", async () => {
    await persistDraft({ silent: true });
    showArticlesEditor();
  });

  articleForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    const submitBtn = articleForm.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    try {
      const saved = await persistDraft();
      if (!saved) return;
      draftArticle = cloneArticle(saved);
      fillItemForm();
      showNote();
      renderArticlesAdmin();
      window.NMArticlesContent?.hydrateArticles?.();
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  });

  articleDeleteBtn?.addEventListener("click", async () => {
    if (!draftArticle) return;
    const confirmed = window.confirm(`Удалить статью «${draftArticle.title || "без названия"}»?`); // eslint-disable-line no-alert
    if (!confirmed) return;
    try {
      await store.deleteArticle(draftArticle.id);
      showArticlesEditor();
      window.NMArticlesContent?.hydrateArticles?.();
    } catch (error) {
      window.alert(error?.message || "Не удалось удалить статью"); // eslint-disable-line no-alert
      renderArticlesAdmin();
    }
  });

  coverImageInput?.addEventListener("change", async () => {
    const file = coverImageInput.files?.[0];
    if (!file) return;
    coverImageInput.disabled = true;
    const url = await uploadImageFile(file);
    coverImageInput.disabled = false;
    coverImageInput.value = "";
    if (!url) return;
    if (coverImageData) coverImageData.value = url;
    updateCoverPreview(url);
  });

  coverImageReset?.addEventListener("click", () => {
    if (coverImageData) coverImageData.value = "";
    if (coverImageInput) coverImageInput.value = "";
    updateCoverPreview("");
  });

  authorSelect?.addEventListener("change", () => {
    if (!draftArticle) return;
    const next = resolveAuthorSnapshot(authorSelect.value, draftArticle);
    draftArticle.authorId = next.authorId;
    draftArticle.authorName = next.authorName;
    draftArticle.authorPost = next.authorPost;
    draftArticle.authorImage = next.authorImage;
  });

  blockCreateBtn?.addEventListener("click", () => {
    openBlockModal(blockTypeSelect?.value || "text", null);
  });

  blocksList?.addEventListener("click", (event) => {
    const editBtn = event.target.closest("[data-articles-block-edit]");
    const deleteBtn = event.target.closest("[data-articles-block-delete]");
    const upBtn = event.target.closest("[data-articles-block-up]");
    const downBtn = event.target.closest("[data-articles-block-down]");
    if (editBtn) {
      openBlockModal(null, editBtn.getAttribute("data-articles-block-edit"));
      return;
    }
    if (deleteBtn && draftArticle) {
      const id = deleteBtn.getAttribute("data-articles-block-delete");
      draftArticle.blocks = draftArticle.blocks.filter((item) => item.id !== id);
      renderBlocksAdmin();
      persistDraft({ silent: true }).then((saved) => {
        if (saved) {
          draftArticle = cloneArticle(saved);
          fillItemForm();
        }
      });
      return;
    }
    if (upBtn) {
      moveBlock(upBtn.getAttribute("data-articles-block-up"), -1);
      return;
    }
    if (downBtn) {
      moveBlock(downBtn.getAttribute("data-articles-block-down"), 1);
    }
  });

  articlesList?.addEventListener("click", (event) => {
    const openBtn = event.target.closest("[data-articles-open]");
    const removeBtn = event.target.closest("[data-articles-remove]");
    if (openBtn) {
      showItemEditor(openBtn.getAttribute("data-articles-open"));
      return;
    }
    if (removeBtn) {
      const id = removeBtn.getAttribute("data-articles-remove");
      const article = store.getArticleById(id);
      const confirmed = window.confirm(`Удалить статью «${article?.title || "без названия"}»?`); // eslint-disable-line no-alert
      if (!confirmed) return;
      store.deleteArticle(id)
        .then(() => {
          renderArticlesAdmin();
          window.NMArticlesContent?.hydrateArticles?.();
        })
        .catch((error) => {
          window.alert(error?.message || "Не удалось удалить статью"); // eslint-disable-line no-alert
          renderArticlesAdmin();
        });
    }
  });

  blockForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (!draftArticle) return;
    const nextBlock = readBlockFromForm();
    if (!nextBlock) {
      window.alert("Заполните обязательные поля блока"); // eslint-disable-line no-alert
      return;
    }
    const index = draftArticle.blocks.findIndex((item) => item.id === nextBlock.id);
    if (index >= 0) draftArticle.blocks[index] = nextBlock;
    else draftArticle.blocks.push(nextBlock);
    closeBlockModal();
    renderBlocksAdmin();
    const saved = await persistDraft();
    if (saved) {
      draftArticle = cloneArticle(saved);
      fillItemForm();
      showNote();
      renderArticlesAdmin();
      window.NMArticlesContent?.hydrateArticles?.();
    }
  });

  document.querySelectorAll("[data-articles-block-modal-close]").forEach((el) => {
    el.addEventListener("click", closeBlockModal);
  });

  window.NMAdminArticlesContent = {
    showArticlesEditor,
    showItemEditor,
    closeBlockModal,
    renderArticlesAdmin,
  };

  if (articlesEditor && !articlesEditor.hidden) showArticlesEditor();
}

initAdminArticlesContent();
